import { ServerUrls } from '~commonInfra/url/ServerUrls';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { ResourceGovernanceService } from '~src/schedule/types/ResourceGovernanceService';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ResourceGovernanceSettingContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getNoDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const ResourceGovernanceSettingDefiniton: ExplorableItemDefinition & SpaceDefinition<'resourceGovernanceSetting'> = {
  itemType: 'resourceGovernanceSetting',
  contentType: 'resourceGovernanceSetting',
  pluralName: Messages.resourceGovernanceSettingPlural,
  singularName: Messages.resourceGovernanceSettingSingular,
  emptyStateMessage: Messages.resourceGovernanceSettingEmptyMessage,
  contentFilterKeys: ResourceGovernanceSettingContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return ResourceGovernanceService.all();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
  contentSpaceUrl: (_urls: SpacesSiteUrls, _contentId: string) => ServerUrls.getInstance().settingsResourceLimitsUrl(),
  headerIconPath: () => imgPath('spaces_masthead_schedule.svg'),
};
